// extracted by mini-css-extract-plugin
export var columnItem = "_dc-3";
export var columnItemDraggable = "_dc-4";
export var dragHandle = "_dc-0";
export var dragHandleHovered = "_dc-1";
export var dropdown = "_dc-5";
export var dropdownContent = "_dc-7";
export var dropdownInner = "_dc-6";
export var filterDropdownHeader = "_dc-8";
export var icon = "_dc-2";
export var sectionDivider = "_dc-9";